import { render, staticRenderFns } from "./MultiTargets.vue?vue&type=template&id=da1448ee&scoped=true&"
import script from "./MultiTargets.vue?vue&type=script&lang=js&"
export * from "./MultiTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1448ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1448ee')) {
      api.createRecord('da1448ee', component.options)
    } else {
      api.reload('da1448ee', component.options)
    }
    module.hot.accept("./MultiTargets.vue?vue&type=template&id=da1448ee&scoped=true&", function () {
      api.rerender('da1448ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/components/MultiTargets.vue"
export default component.exports